import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const NavigationButtons = ({
  currentStep,
  totalSteps,
  onPrevious,
  onNext,
  isNextDisabled
}) => {
  return (
    <div className="flex justify-between gap-3 sm:gap-4 mt-8 sm:mt-12 pt-6 sm:pt-8 border-t-2 border-gray-200">
      <button
        onClick={onPrevious}
        disabled={currentStep === 1}
        className="inline-flex items-center justify-center px-3 sm:px-4 py-2 text-xs sm:text-sm font-medium rounded-md border-2 border-black text-black hover:bg-black hover:text-white transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
      >
        <ChevronLeft className="w-3.5 h-3.5 sm:w-4 sm:h-4 mr-1.5 sm:mr-2" />
        Previous
      </button>
      {currentStep < totalSteps && currentStep !== 4 && (
        <button
          onClick={onNext}
          disabled={isNextDisabled}
          className="inline-flex items-center justify-center px-3 sm:px-4 py-2 text-xs sm:text-sm font-medium rounded-md bg-black text-white border-2 border-black hover:bg-gray-900 transition-colors disabled:opacity-50 disabled:cursor-not-allowed disabled:bg-gray-400 disabled:border-gray-400"
        >
          Next Step
          <ChevronRight className="w-3.5 h-3.5 sm:w-4 sm:h-4 ml-1.5 sm:ml-2" />
        </button>
      )}
    </div>
  );
};

export default NavigationButtons;

